module.exports = __webpack_public_path__ + "static/media/photo108.2eb13b6f.jpg";